export const APPLICATION_LOAD_ERROR = 'APPLICATION_LOAD_ERROR';
